import styled from 'styled-components';
import AppCSS from '../../../utils/styled';
import { SMALLER_BUTTON_WIDTH } from '../../../utils/styled/dimensions';

export const Components = {
  ModalBodyContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    padding: 16px 0;
    width: 100%;
  `,
  Description: styled.span`
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.greys.veryDark};
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label14Medium};
    color: ${AppCSS.colors.black};
    margin-top: 8px;
  `,
  ReadOnlyField: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: ${AppCSS.colors.greys.light};
  `,
  ReadOnlyValue: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  NotSetValue: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.greys.prettyDark};
  `,
  TextArea: styled.textarea`
    width: 100%;
    min-height: 100px;
    padding: 12px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
    background-color: transparent;
    resize: vertical;
    outline: none;

    &:disabled {
      background-color: ${AppCSS.colors.greys.light};
      cursor: not-allowed;
    }
  `,
  ModalButtonsContainer: styled.div`
    width: 100%;
    padding: 12px 0;
    grid-gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  Button: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${SMALLER_BUTTON_WIDTH}px;
    min-width: ${SMALLER_BUTTON_WIDTH}px;
  `,
  TertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,
};
